import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setMediaList } from "../store/media/slice";
import { setPage } from "../store/pagination/slice";

const useRouteChangeReset = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(setMediaList({}));
    dispatch(setPage(0));
  }, [pathname, dispatch]);
};

export default useRouteChangeReset;
